import { createFileRoute } from "@tanstack/react-router"
import { Tabs, TabList, Tab, TabPanels, TabPanel, Box } from "@chakra-ui/react"
import EmployeesSchedulePage from "../../components/WorkSchedule/EmployeesSchedulePage.tsx"
import { ShiftsListPage } from "../../components/Shifts/ShiftsPage.tsx"
import { useTranslation } from "react-i18next"

function EmployeesAndShiftsTabs() {
  const { t } = useTranslation()
  return (
    <Box p={2}>
      <Tabs isFitted variant="enclosed">
        <TabList mb="1em">
          <Tab>{t("sidebar.employeesSchedule")}</Tab>
          <Tab>{t("sidebar.shiftEntries")}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel p={0}>
            <EmployeesSchedulePage />
          </TabPanel>
          <TabPanel p={0}>
            <ShiftsListPage />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export const Route = createFileRoute("/_layout/employees-schedule")({
  component: EmployeesAndShiftsTabs,
})
